require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-stephanie-lingwood.json") })
        }
      }, "path---blog-author-stephanie-lingwood");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-stephanie-lingwood!./.cache/json/blog-author-stephanie-lingwood.json
// module id = 702
// module chunks = 231608221292675